<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5">
      <div class="bootstrap-dialog-title">Add users</div>
    </h2>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <div class="selection-container">
      <p class="selection-text">Choose your preferred method to add users to your organization:</p>

      <div class="action-options">
        <div class="action-option" (click)="selectAction(UserActionType.ADD_NEW)">
          <div class="option-content">
            <div class="option-icon">
              <img
                src="./assets/icons/add-user-svgrepo-com.svg"
                width="24"
                height="24"
                alt="Add user"
              />
            </div>
            <div class="option-details">
              <h6 class="option-title">Add new user</h6>
              <p class="option-description">
                Manually create a single user account with complete details
              </p>
            </div>
          </div>
          <div class="option-arrow">
            <!-- Thin chevron -->
            <i class="fa fa-chevron-right" style="font-weight: 300"></i>
          </div>
        </div>

        <div class="action-option" (click)="selectAction(UserActionType.IMPORT)">
          <div class="option-content">
            <div class="option-icon">
              <img
                src="./assets/icons/import-svgrepo-com.svg"
                width="25"
                height="25"
                alt="Import users"
              />
            </div>
            <div class="option-details">
              <h6 class="option-title">Import users</h6>
              <p class="option-description">
                Bulk import multiple users using an Excel spreadsheet
              </p>
            </div>
          </div>
          <div class="option-arrow">
            <i class="fa fa-chevron-right" style="font-weight: 300"></i>
          </div>
        </div>

        <div class="action-option" (click)="selectAction(UserActionType.SHARE_LINK)">
          <div class="option-content">
            <div class="option-icon">
              <img
                src="./assets/icons/link-round-svgrepo-com.svg"
                width="24"
                height="24"
                alt="Share link"
              />
            </div>
            <div class="option-details">
              <h6 class="option-title">Share invitation link</h6>
              <p class="option-description">Generate a secure link for users to self-register</p>
            </div>
          </div>
          <div class="option-arrow">
            <i class="fa fa-chevron-right" style="font-weight: 300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
